<template>

    <div class="col-12" v-if="efficiencyGrid">
      <line-chart v-bind:datasets="lineChartDataset"
                  v-bind:show-legend="false"
                  :animation-duration=0
                  :height=null
                  :width=null
                  v-bind:y-axes-begin-at-zero="true"/>

    </div>


</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import {LineChart, LineChartDataset} from '../../../common/chart';

  export default {
    props: {
      'efficiencyGrid': {
        type: [Array, Object],
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
      };
    },
    components: {
      LineChart,
      Loader,
    },

    computed: {
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      lineChartDataset() {
        return [this.fetchLineDatasetForChart()];
      },
    },

    methods: {

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
      },

      fetchLineDatasetForChart() {
        let data = [], i = 0;
        forEach(this.efficiencyGrid, (item) => {
          data.push(
              {
                x: this.toLocaleDate(item.day),
                y: item.percent,
              },
          );
        });

        return new LineChartDataset({
          data,
        });

      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/reports/components/DataEfficiency.vue